import { render, staticRenderFns } from "./WorkTaskReportTab.vue?vue&type=template&id=71454674"
import script from "./WorkTaskReportTab.vue?vue&type=script&lang=ts"
export * from "./WorkTaskReportTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports